import React from "react";

function Goals() {
	return <h1>Goals content</h1>;
}

export default Goals;
